@if (saveTimestamp()) {
	<div class="contentWrapper mat-elevation-z1 {{ statusDisplay().color }} {{ variant() }}" [@zoomInOnEnter] [@zoomOutOnLeave]>
		<div class="borderBar"></div>

		<div class="iconWrapper">
			<i
				class="fas"
				[ngClass]="{
					'fa-spinner fa-spin': state() === AutosaveState.Busy,
					'fa-check-circle': state() === AutosaveState.Success,
					'fa-exclamation-triangle': state() === AutosaveState.Warn,
					'fa-times-circle': state() === AutosaveState.Error,
				}"
			>
			</i>
		</div>

		<div class="labelWrapper">
			<label class="primaryLabel">{{ statusDisplay().label | translate }}</label>
			<label class="secondaryLabel">
				{{ T.AUTOSAVE_WIDGET_LAST_SAVE | translate }} :
				{{ saveTimestamp() | date: (T.DATE_FORMAT_AUTOSAVE_WIDGET | translate) :'': translate.currentLang }}
			</label>
		</div>

		<section class="animated" [class.active]="!!hint && (state() === AutosaveState.Error || state() === AutosaveState.Warn)">
			<span class="hint" [innerHTML]="hint ? (hint | translate) : null"></span>
		</section>
	</div>
}
